import React from 'react';
import { Link } from 'react-router-dom';
export const Login = () => {
  return <div className="py-20 lg:py-24 bg-gray50 min-h-[calc(100vh-300px)] flex items-center justify-center" data-id="element-815">
      <div className="max-w-md w-full px-5" data-id="element-816">
        <div className="bg-white p-8 md:p-10 rounded-2xl border border-gray200 shadow-xl" data-id="element-817">
          <div className="text-center mb-8" data-id="element-818">
            <h1 className="text-3xl font-heading font-bold text-ink mb-2" data-id="element-819">
              Sign In
            </h1>
            <p className="text-gray-500" data-id="element-820">
              Access your account and saved designs
            </p>
          </div>

          <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-821">
            <div data-id="element-822">
              <label className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-823">
                Email Address
              </label>
              <input type="email" className="w-full px-4 py-3 rounded-md border border-gray300 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" placeholder="you@example.com" data-id="element-824" />
            </div>
            <div data-id="element-825">
              <div className="flex items-center justify-between mb-1.5" data-id="element-826">
                <label className="block text-sm font-bold text-charcoal" data-id="element-827">
                  Password
                </label>
                <a href="#" className="text-xs text-brandRed hover:text-brandRedDark font-medium" data-id="element-828">
                  Forgot?
                </a>
              </div>
              <input type="password" className="w-full px-4 py-3 rounded-md border border-gray300 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" placeholder="••••••••" data-id="element-829" />
            </div>
            <button type="button" className="w-full bg-brandRed hover:bg-brandRedDark text-white font-bold py-3.5 rounded-md transition-colors mt-2" data-id="element-830">
              Sign In
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-gray100 text-center" data-id="element-831">
            <p className="text-sm text-gray-600 mb-3" data-id="element-832">Don't have an account?</p>
            <Link to="/wholesale-apply" className="inline-block w-full bg-white border-2 border-charcoal hover:bg-charcoal hover:text-white text-charcoal font-bold py-3 rounded-md transition-colors" data-id="element-833">
              Create Account
            </Link>
          </div>
        </div>
      </div>
    </div>;
};